export const BANK_CODE = "bank_code";

export const BANK_NAME = "bank_name";

export const GENDER = "gender";

export const EMAIL = "email";

export const FIRST_NAME = "first_name";

export const LAST_NAME = "last_name";

export const POSITION = "position";

export const PHONE_NUMBER = "phone_number";
